import { useApiMutation, useApiQuery } from "@/hooks/use-api";
import {
  ResourceGroup,
  ResourceGroupCreate,
  ResourceGroupUpdate,
  ResourceType,
} from "@/models/resource-group";
import { hasSelectedWorkspace } from "./core";

/**
 * Fetch all resource groups
 */
export const useResourceGroups = (resourceType?: ResourceType) =>
  useApiQuery<ResourceGroup[]>(
    {
      url: resourceType
        ? `resource_groups?fields=*.*&resource_type=${resourceType}`
        : "resource_groups?fields=*.*",
    },
    { enabled: hasSelectedWorkspace(), staleTime: 2 * 60 * 1000 }
  );

/**
 * Fetch a single resource group by ID
 */
export const useResourceGroup = (id?: string) =>
  useApiQuery<ResourceGroup>(
    { url: `resource_groups/${id}?fields=*.*` },
    { enabled: !!id && hasSelectedWorkspace() }
  );

/**
 * Create a new resource group
 */
export const useCreateResourceGroup = () =>
  useApiMutation<ResourceGroup, ResourceGroupCreate>({
    url: "resource_groups",
    method: "POST",
  });

/**
 * Update an existing resource group
 */
export const useUpdateResourceGroup = () =>
  useApiMutation<ResourceGroupUpdate, ResourceGroupUpdate, { id: string }>({
    url: "resource_groups/{id}",
    method: "PATCH",
  });

/**
 * Delete a resource group
 */
export const useDeleteResourceGroup = () =>
  useApiMutation<unknown, object, { id: string }>({
    url: "resource_groups/{id}",
    method: "DELETE",
  });

